import React from 'react';
import { Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';

import messages from '../../assets/i18n'

export default function ConciliationFilter() {

  const dispatch = useDispatch();

  const lang = useSelector(state => state.language.name);
  const filters = useSelector(state => state.conciliationResult.filter);

  const sortMessages = messages[lang].conciliationFilterSort;

  const pageMessages = messages[lang].conciliationListFilters;

  const setFilters = (newFilters) => {
    dispatch({
      type: 'SET_CONCILIATION_FILTER',
      payload: newFilters
    })
  };

  const onEnterFilter = (e) => {
    if (e.keyCode === 13) {
      dispatch({
        type: 'GET_CONCILIATION_LIST',
        page: 1,
        filter: filters,
        cleanTable: true
      })
    }
  }

  const statusFilter = [
    { id: "", message: messages[lang].all },
    { id: "0", message: pageMessages.naoEnviado },
    { id: "1", message: pageMessages.enviado },
    { id: "2", message: pageMessages.conciliado },
    { id: "3", message: pageMessages.reprovado },
    { id: "4", message: pageMessages.condicional },
  ];

  const sortConciliation = [
    { id: "pedido asc",        message: sortMessages.pedidoAsc},
    { id: "pedido desc",       message: sortMessages.pedidoDesc},   
    { id: "fornecedor asc",    message: sortMessages.fornecedorAsc},   
    { id: "fornecedor desc",   message: sortMessages.fornecedorDesc},   
    { id: "numeroConciliacao asc",  message: sortMessages.numeroConciliacaoAsc},   
    { id: "numeroConciliacao desc", message: sortMessages.numeroConciliacaoDesc},
    { id: "dataConciliacao asc", message: sortMessages.dataConciliacaoAsc},
    { id: "dataConciliacao desc", message: sortMessages.dataConciliacaoDesc},
  ];

  return (
    <Form className="px-3">
      <Row>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.numeroConciliacao}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.numeroConciliacao}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, conciliacao: event.target.value },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.pedido}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.pedido}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, pedido: event.target.value },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.fornecedor}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.fornecedor}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, nomeFornecedor: event.target.value },
                    )}
                />
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.dataInicial}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.dataInicial}
                    type="date"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, dataConciliacaoInicial: event.target.value },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.dataFinal}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.dataFinal}
                    type="date"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, dataConciliacaoFinal: event.target.value },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.statusComercial}</Form.Label>
                <Form.Control
                    as="select"
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.statusComercial}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, statusComercial: event.target.value },
                    )}
                >
                {
                  statusFilter.map(value => (
                    <option key={value.id} value={value.id}>{value.message}</option>
                  ))
                }
                </Form.Control>
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.statusRFM}</Form.Label>
                <Form.Control
                    as="select"
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.statusRFM}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, statusRFM: event.target.value },
                    )}
                >
                {
                  statusFilter.map(value => (
                    <option key={value.id} value={value.id}>{value.message}</option>
                  ))
                }
                </Form.Control>
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.notaFiscal}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.notaFiscal}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, notaFiscal: event.target.value },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{sortMessages.sortBy}</Form.Label>
                <Form.Control
                    as="select"
                    className="text-2 border-radius-full"
                    placeholder={sortMessages.sortBy}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, orderBy: event.target.value },
                    )}
                >
                {
                  sortConciliation.map(value => (
                    <option key={value.id} value={value.id}>{value.message}</option>
                  ))
                }
                </Form.Control>
        </Form.Group>
      </Row>
    </Form>
  );
}
